"use strict";

document.addEventListener("DOMContentLoaded", function() {
    // See https://masonry.desandro.com/options.html
    const grid = document.querySelector(".grid");

    const masonry_options = {
        itemSelector: ".grid-item",
        columnWidth: ".grid-item",
        percentPosition: true,
        gutter: ".gutter-sizer",
        horizontalOrder: true
    };

    const masonry = new Masonry(grid, masonry_options);

    if (masonry_meta && masonry && grid) {
        masonry_meta.grid = grid;

        masonry_meta.masonry = masonry;

        update_last_masonry_item();

        // See https://imagesloaded.desandro.com/
        imagesLoaded(masonry_meta.grid).on("progress", function() {
            // layout Masonry after each image loads
            masonry_meta.masonry.layout();
        });
    }
});

function update_last_masonry_item() {
    const last_item = document.querySelector(".grid article:last-of-type");

    if (last_item) {
        masonry_meta.last_item = last_item;

        window.addEventListener("scroll", check_last_item_scroll_position);
    }
}

function check_last_item_scroll_position() {
    if (!masonry_meta.next_page || !masonry_meta.last_item) {
        window.removeEventListener("scroll", check_last_item_scroll_position);

        return;
    }

    const rect = masonry_meta.last_item.getBoundingClientRect();

    // Check if the last item is about to be scrolled into the viewport, then trigger load more
    if (rect.top <= window.innerHeight + 600) {
        load_more_masonry_items();
    }
}

function load_more_masonry_items() {
    const next_page = masonry_meta.next_page;

    const projecttax_id = masonry_meta.projecttax_id;

    const taxonomy = masonry_meta.taxonomy;

    masonry_meta.next_page = null;

    const rest_url = `${masonry_meta.rest_base}?next_page=${next_page}
    &projecttax_id=${projecttax_id}
    &taxonomy=${taxonomy}
    `;

    fetch(rest_url)
        .then(response => response.json())
        .then(response_json => append_masonry_items(response_json))
        .catch(e => console.log(e));
}

function append_masonry_items(response_json) {
    if (response_json.html) {
        const html_fragment = document
            .createRange()
            .createContextualFragment(response_json.html);

        const projects = html_fragment.querySelectorAll("article");

        masonry_meta.grid.appendChild(html_fragment);

        masonry_meta.masonry.appended(projects);

        // See https://imagesloaded.desandro.com/
        imagesLoaded(masonry_meta.grid).on("progress", function() {
            // layout Masonry after each image loads
            masonry_meta.masonry.layout();
        });
    }

    if (response_json.next_page) {
        masonry_meta.next_page = parseInt(response_json.next_page);

        update_last_masonry_item();
    }
}
